import { Constants } from '../../../constants/constants';
import { Component, OnInit, ViewChild } from '@angular/core';
import { QuestionDto } from '../../../dto/justino/question.dto';
import { ModalVideoComponent } from '../modal-video/modal-video.component';

@Component({
  selector: 'app-bot',
  templateUrl: './bot.component.html',
  styleUrl: './bot.component.scss',
})
export class BotComponent implements OnInit {
  userID!: string;
  botFlag = true;
  sessionID!: string;
  isAutehnticated = false;
  questions: QuestionDto[] = [];

  @ViewChild(ModalVideoComponent)
  modalVideo!: ModalVideoComponent

  constructor() {}

  // Método que se ejecuta al inicializar el componente
  ngOnInit(): void {
    this.sessionID = '';
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}'
    );
    if (
      infoInicioSesion !== null &&
      Object.keys(infoInicioSesion).length !== 0
    ) {
      // El usuario está autenticado, se obtiene el token de la sesión
      this.isAutehnticated = true;
      const userData = JSON.parse(
        sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
      );
      this.userID = String(userData.idUsuario);
      this.abrirModalVideo();
    }
  }

  selectedAnswers: { [key: number]: string } = {};

  onOptionSelect(questionId: number, option: string): void {
    this.selectedAnswers[questionId] = option;
  }

  onSubmit(): void {
    console.log('Selected Answers:', this.selectedAnswers);
    alert('Your answers have been submitted!');
  }

  abrirModalVideo() {
    const videoSeen = localStorage.getItem(Constants.VIDEO_SEEN);
    const isVideoShow = !(videoSeen !== null);
    if(isVideoShow) {
      localStorage.setItem(Constants.VIDEO_SEEN, 'true');
      setTimeout(() => {
        this.modalVideo.abrirCerrarModal();
      }, 500);
    }
  }
}
